import { render } from "./sys_setting.vue?vue&type=template&id=5b1c22e0&scoped=true"
import script from "./sys_setting.vue?vue&type=script&lang=js"
export * from "./sys_setting.vue?vue&type=script&lang=js"

import "./sys_setting.vue?vue&type=style&index=0&id=5b1c22e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1c22e0"]])

export default __exports__